module.exports = "https://www.gc-qa.gnp.com.mx/2ead118f881d5920929a93f374dc9825.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videodesk.png
// module id = 8174
// module chunks = 0